// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-17257b0e]{background-color:#f8f8f8;min-height:88px;overflow-x:auto}.wrapper .reciever-channel-mobile[data-v-17257b0e]{height:80px;width:-moz-max-content;width:max-content}[data-v-17257b0e]::-webkit-scrollbar{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
